import { getProductLineId, getProductId } from './../../order-builder/modules/specification/helpers/product.helper';
import { Injectable } from '@angular/core';
import { PlantsRequest, PlantsService } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { State } from '../reducers';
import {
  OneClickLoadPlantsCompleteAction,
  OneClickPlantsActionTypes,
  OneClickLoadPlantsAction,
} from '../actions/one-click-plants.actions';
import { getOneClickState, OneClickState } from '../reducers';

@Injectable()
export class OneClickRegionPlantsEffects {
  oneClickPlants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OneClickPlantsActionTypes.LOAD_PLANTS),
      switchMap((action: OneClickLoadPlantsAction) =>
        this.store.select(getOneClickState).pipe(
          filter((state) => !!state.productsState.selected),
          take(1),
          map((state) => {
            return { state, index: action.index };
          }),
        ),
      ),
      map(({ state, index }) => {
        return {
          request: this.makePlantsRequestFromState(state, index),
          index: index,
        };
      }),
      switchMap(({ request, index }) =>
        this.plantService.getPlants(request).pipe(
          map((response) => {
            return { response, index };
          }),
        ),
      ),
      map(({ response, index }) => new OneClickLoadPlantsCompleteAction(response.plants, index)),
    ),
  );

  private makePlantsRequestFromState(state: OneClickState, index = 0): PlantsRequest {
    return {
      countryCode: state.shippingMethodsState.selected.countryCode,
      shippingConditionId: state.shippingMethodsState.selected.shippingConditionId,
      regionCode: state.jobsiteState.selected.jobsite.address
        ? state.jobsiteState.selected.jobsite.address.regionCode
        : state.profileState.presetOrder.items[index].shippingSource.address.regionCode,
      productLineId: getProductLineId(state.productsState.selected[index]),
      productId: `${getProductId(state.productsState.selected[index])}`,
    } as PlantsRequest;
  }

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private plantService: PlantsService,
  ) {}
}
